import * as React from 'react';
import * as PopoverPrimitive from '@radix-ui/react-popover';
import { cn } from '../../lib/utils';
import { appLayerProps } from './app-layer';

/**
 * A small floating panel anchored to a real trigger element — Radix
 * `Popover`, the sibling of `context-menu.tsx`'s `DropdownMenu` wrapper for
 * the case where there IS a DOM element to anchor to (a toolbox button),
 * not an arbitrary click point. Same guarantees DESIGN §4 asks of every
 * popup: portalled to `document.body`, `position: fixed` under the hood,
 * viewport-clamped, dismisses on mousedown-outside (Radix's default), never
 * clipped by a scrolled/zoomed ancestor.
 */
export const Popover = PopoverPrimitive.Root;
export const PopoverTrigger = PopoverPrimitive.Trigger;
export const PopoverAnchor = PopoverPrimitive.Anchor;

export const PopoverContent = React.forwardRef<
  React.ElementRef<typeof PopoverPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content>
>(({ className, sideOffset = 6, ...props }, ref) => (
  <PopoverPrimitive.Portal>
    <PopoverPrimitive.Content
      ref={ref}
      sideOffset={sideOffset}
      {...appLayerProps}
      collisionPadding={8}
      className={cn('z-popover outline-none', className)}
      {...props}
    />
  </PopoverPrimitive.Portal>
));
PopoverContent.displayName = 'PopoverContent';
